import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export const exportFromArrayToExcel = (collumns: string[], rows: string[][]) => {

  // monta a matriz com header + linhas
  const worksheetData = [collumns, ...rows];
  const ws = XLSX.utils.aoa_to_sheet(worksheetData);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Dados");

  const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
  saveAs(blob, "relatorio.xlsx");
};

export const exportFromTableToExcel = (tableId: string, fileName = "relatorio.xlsx") => {
  const table = document.getElementById(tableId) as HTMLTableElement | null;
  if (!table) {
    console.error(`Tabela com id "${tableId}" não encontrada.`);
    return;
  }

  // transforma a tabela HTML em worksheet
  const ws = XLSX.utils.table_to_sheet(table);

  // cria um novo workbook
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Dados");

  // gera o arquivo e baixa
  const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
  saveAs(blob, fileName);
};